import { render, staticRenderFns } from "./LeaderboardList.vue?vue&type=template&id=76db0c24&"
import script from "./LeaderboardList.vue?vue&type=script&lang=js&"
export * from "./LeaderboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports